export default __webpack_public_path__ + "static/media/kavery-logo.d1be879f.svg";